var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup53(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.234,
    height: 172.5,
    viewBox: "0 0 96.234 172.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(-686.741 -2075.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1798.733,1247.92h-45.215c-7,0-11.688-5.694-10.454-12.694l25.241-143.147c1.234-7,7.932-12.693,14.93-12.693h45.215c7,0,11.688,5.694,10.454,12.693l-25.241,143.147c-1.234,7-7.932,12.694-14.93,12.694m-16.249-164.273a10.509,10.509,0,0,0-9.918,8.432l-25.241,143.147a6.887,6.887,0,0,0,6.945,8.432h45.214a10.508,10.508,0,0,0,9.918-8.432l25.241-143.147a6.888,6.888,0,0,0-6.945-8.432Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1822.693,1103.405h-42.771a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M1815.685,1081.938H1794.3a1.167,1.167,0,0,1-1.178-1.431l.645-3.657a1.78,1.78,0,0,1,1.683-1.43h21.385a1.168,1.168,0,0,1,1.179,1.43l-.645,3.657a1.781,1.781,0,0,1-1.683,1.431",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1799.147,1236.938h-42.771a2.336,2.336,0,0,1-2.357-2.861l1.29-7.315a3.562,3.562,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1802.511,1217.862H1759.74a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1805.875,1198.786H1763.1a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1809.539,1179.71h-42.771a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.561,3.561,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1812.9,1160.633h-42.771a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861H1815.2a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1816.266,1141.557h-42.771a2.335,2.335,0,0,1-2.357-2.861l1.29-7.315a3.561,3.561,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.56,3.56,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M1819.329,1122.481h-42.771a2.336,2.336,0,0,1-2.357-2.861l1.29-7.315a3.562,3.562,0,0,1,3.365-2.861h42.772a2.334,2.334,0,0,1,2.356,2.861l-1.29,7.315a3.559,3.559,0,0,1-3.365,2.861",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup53);
export default __webpack_public_path__ + "static/media/Group 53.83fb437d109ff76f6b7bef019ada18f0.svg";
export { ForwardRef as ReactComponent };